module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_case_02-0c0a41bd17b926663b487cee91d18b93.png";